import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { SMSResponse, SMSDetails } from '../models/sms.model';
import { SimpleResponse } from '../models/genericResponse.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';


@Injectable()
export class SMSService {
    private baseUrl: string;
    private api: string = "api/SMS";
    
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('SMS Service Client Side Error: ', errorResponse.error.message);
        } else {
            throw errorResponse;
        }
    }

    async sndSMSAsync(encryptedUser: string, sms: SMSDetails): Promise<SMSResponse | void> {
        const a = await this.httpClient.post<SMSResponse>(this.baseUrl, sms, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + encryptedUser
            })
        }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, sms, "", encryptedUser, "SMSService", "sndSMSAsync"); });
 

        return a;
  }
  
  async sndPayRemSMSAsync(encryptedUser: string, sms: SMSDetails,dtSend:string): Promise<SMSResponse | void> {
    const a = await this.httpClient.post<SMSResponse>(`${this.baseUrl}/SendReminder/${dtSend}`, sms, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Basic ' + encryptedUser
      })
    }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, sms, "dtSend - " + dtSend, encryptedUser, "SMSService", "sndPayRemSMSAsync"); });
 
    return a;
  }

    async getSMSResultAsync(encryptedUser: string, txtMsgId: number): Promise<SimpleResponse | void> {
        const a = await this.httpClient
            .get<SimpleResponse>(`${this.baseUrl}/GetResult/${txtMsgId}`, {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "txtMsgId - " + txtMsgId, encryptedUser, "SMSService", "getSMSResultAsync"); });

        return a;
    }
}
